"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-white/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-white/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-white/20 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-base font-medium text-foreground hover:text-foreground/80 transition-all duration-[var(--duration-medium)] px-2 py-1 hover:bg-transparent focus:bg-transparent">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
const socialLinks = [{
  icon: Facebook,
  label: "Facebook",
  href: "https://facebook.com/StrategyAI Partners"
}, {
  icon: Twitter,
  label: "Twitter",
  href: "https://twitter.com/StrategyAI Partners"
}, {
  icon: Linkedin,
  label: "LinkedIn",
  href: "https://linkedin.com/company/StrategyAI Partners"
}, {
  icon: Instagram,
  label: "Instagram",
  href: "https://instagram.com/StrategyAI Partners"
}];
export default function Footer() {
  return <footer id="footer" className="dark-section w-full py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="glass-effect rounded-lg p-6 md:p-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex-shrink-0">
              <Link to="/HomePage">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541635/img/strategy_ai_partners_official_logo-light.png" alt="StrategyAI Partners" className="h-7" />
              </Link>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-8">
              <MenuProvider menu_id="34">
                <FooterMenuConsumer />
              </MenuProvider>

              <div className="flex items-center gap-4">
                {socialLinks.map((social, i) => <Link key={social.label} to={social.href} newTab data-index={i} className="text-foreground hover:text-foreground/80 transition-all duration-[var(--duration-medium)] p-1.5 hover:bg-transparent group" aria-label={social.label}>
                    <social.icon className="size-5 group-hover:scale-110 transition-transform duration-[var(--duration-medium)]" />
                  </Link>)}
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/5 text-center">
            <p className="text-xs text-foreground mb-2 uppercase tracking-widest font-medium">
              Trusted by Global Enterprise Leaders | Data-Driven Precision | Scalable AI Architectures
            </p>
            <p className="text-sm text-foreground">
              &copy; {new Date().getFullYear()} StrategyAI Partners. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}